import {AllocatableLoadSettings, AllocatableLoadSettingsEntity} from "../../../model/allocatable-load-settings";
import {makeEntitySelectors} from "../base-entity-store";

export interface AllocatableLoadSettingsSelectorProps {

}

const allocatableLoadSettingsSelectors = makeEntitySelectors<
  AllocatableLoadSettings,
  AllocatableLoadSettingsEntity,
  AllocatableLoadSettingsSelectorProps
>({
  defaultProps: {},

  filter: (_v, _props) => true,

  transform: (value) => AllocatableLoadSettingsEntity.from(value),
});

export const allocatableLoadSettingsListSelector =
  (props?: AllocatableLoadSettingsSelectorProps) =>
    allocatableLoadSettingsSelectors.listSelector(props);

export const allocatableLoadSettingsSelector =
  () => allocatableLoadSettingsSelectors.singleSelector();
